/**
 *
 * Details Service Reducer
 *
 */
import get from 'lodash/get';
import { NOT_ASKED, LOADING, SUCCESS, FAILURE, UPDATE_CURRENT_TRANSFER } from './constants';

function reducer(state = {}, action) {
  switch (action.type) {
    case NOT_ASKED:
      return { status: NOT_ASKED };
    case LOADING:
      return { status: LOADING, params: action.params };
    case SUCCESS:
      return { ...state, status: SUCCESS, result: action.result };
    case FAILURE:
      return { ...state, status: FAILURE, error: action.error };
    case UPDATE_CURRENT_TRANSFER:
      return { ...state, result: updateTransfer(action.newData, state.result) };
    default:
      return state;
  }
}

export function updateTransfer(newData, transfer) {
  // update the relevant portions
  return {
    ...transfer,
    prescribedActions: newData.prescribedActions,
    auditEvents: newData.auditEvents,
    state: newData.state,
    amount: newData.amount,
    beneficiary: get(newData, 'beneficiary', null),
    beneficiaryAddress: get(newData, 'beneficiary.address', null),
    wireIsThirdParty: get(newData, 'beneficiary.isThirdParty', null),
    wireIsDomestic: get(newData, 'isDomestic', null),
  };
}

export default reducer;



// WEBPACK FOOTER //
// ./src/services/details/reducer.js